export default __webpack_public_path__ + "static/media/Group 11800_1.6a6752a5.svg";